<template>
    <div class="eval-page-container">
        <!-- main contents -->
        <EvalHeader :rightButtonHandler="goBackHandler" pageName="main" :goHomeHandler="goHomeHandler" />
        <div class="eval-page">
            <div class="section-one">
                <div class="title-box">
                    <img class="icon" :src="require(`@/assets/images/icons/face-id.svg`)" />
                    <div class="title">외모 취향 평가</div>
                    <!-- <div class="desc">({{ currentUserIndex + 1 }}/10명)</div> -->
                </div>
            </div>

            <!-- loading -->
            <div v-if="loading" class="loading-container">
                <DotFadeSpinner />
                <div class="loading-message">불러오는 중..</div>
            </div>

            <div v-if="!loading" class="section-two">
                <div class="title">소개팅을 수락하시겠어요?</div>
                <div class="desc">
                    <p>*조건은 마음에 든다고 가정하고 평가해주세요.</p>
                </div>

                <div class="target-box">
                    <div class="user-index-box">
                        ({{ users.filter(item => item.is_enabled === true).indexOf(users[currentUserIndex]) + 1 }}/{{
                            users.filter(item => item.is_enabled === true).length
                        }}명)
                    </div>

                    <swiper :options="swiperOption" :key="currentUserIndex" ref="mySwiper">
                        <swiper-slide v-for="(img, i) in currentImages" :key="i">
                            <div class="slide-img-wrapper">
                                <img :src="img" class="user-image" />

                                <div class="bottom-inner-shadow"></div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                    <div class="target-info">
                        <div class="left">{{ users[currentUserIndex] ? users[currentUserIndex].age : '-' }}세</div>
                        <div class="right">{{ users[currentUserIndex] ? users[currentUserIndex].height : '-' }}cm</div>
                    </div>
                </div>
                <!-- <div class="target-box">
                    <div class="img-container">

                        <swiper :options="swiperOption" :key="currentUserIndex" ref="mySwiper">
                            <swiper-slide v-for="(img, i) in currentImages" :key="i">
                                <div class="slide-img-wrapper">
                                    <img :src="img" class="user-image" />
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>

                    </div>
                    <div class="target-info">
                        <div class="left">
                            <img class="icon" :src="require(`@/assets/images/icons/user-check.svg`)" />
                            <div class="">
                                {{ users[currentUserIndex].age }}세
                            </div>
                        </div>
                        <div class="right">
                        {{ users[currentUserIndex].height }}cm
                        </div>
                    </div>
                </div> -->
            </div>

            <div v-if="!loading" class="section-three">
                <button class="btn reject" @click="rejectTarget">
                    <p class="label f-regular">거절</p>
                </button>
                <button class="btn accept" @click="acceptTarget">
                    <p class="label f-regular">만남 수락</p>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'
import EvalHeader from './EvalHeader.vue'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: 'EvaluationMainPage',
    components: {
        EvalHeader,
        swiper,
        swiperSlide,
        // Swiper,
        // SwiperSlide
    },
    data: () => ({
        loading: true,
        isDataRefreshed: false,

        currentUserIndex: 0,

        users: [
            // { is_look_accepted: false, age: 31, height: 171, photo_urls: ['/img/u1_1.jpg', '/img/u1_2.jpg', '/img/u1_3.jpg'] },
            // { is_look_accepted: true, age: 32, height: 172, photo_urls: ['/img/u2_1.jpg', '/img/u2_2.jpg', '/img/u2_3.jpg'] },
            // { is_look_accepted: null, age: 33, height: 173, photo_urls: ['/img/u2_1.jpg', '/img/u2_2.jpg', '/img/u2_3.jpg'] },
            // { is_look_accepted: null, age: 34, height: 174, photo_urls: ['/img/u2_1.jpg', '/img/u2_2.jpg', '/img/u2_3.jpg'] },
            // { is_look_accepted: null, age: 35, height: 175, photo_urls: ['/img/u2_1.jpg', '/img/u2_2.jpg', '/img/u2_3.jpg'] },
            // { is_look_accepted: null, age: 36, height: 176, photo_urls: ['/img/u2_1.jpg', '/img/u2_2.jpg', '/img/u2_3.jpg'] },
        ],

        swiperOption: {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            loop: false,
        },
    }),
    computed: {
        me() {
            return this.$store.getters.me || {}
        },
        aiRating() {
            return (this.me.ai_ratings || []).find(item => item.status === 'created' || item.status === 'in_progress')
        },
        currentImages() {
            return this.users.length > 0 ? this.users[this.currentUserIndex].photo_urls : []
        },
    },
    watch: {
        'aiRating.evaluation_data': {
            async handler(newVal) {
                if (newVal) {
                    console.log('newVal', newVal)
                    if (!this.isDataRefreshed) {
                        // refresh 로직 수행
                        this.isDataRefreshed = true
                        const res = await userService.refreshAiRating(this.me.id)
                        if (res.msg.indexOf('refreshed') !== -1) {
                            // 변화가 있으니 dispatch 필요함
                            console.log('외모 평가를 재생성 했습니다.')
                            this.loading = true

                            await this.$store.dispatch('loadMe')

                            this.loading = false
                            const parsedVal = JSON.parse(
                                (
                                    (this.$store.getters.me.ai_ratings || []).find(
                                        item => item.status === 'created' || item.status === 'in_progress'
                                    ) || []
                                ).evaluation_data
                            )
                            this.users = parsedVal
                            const currentIndex = parsedVal.findIndex(
                                item => item.is_look_accepted === null && item.is_enabled === true
                            )
                            console.log('currentIndex', currentIndex)
                            if (currentIndex >= 0) {
                                this.currentUserIndex = currentIndex
                            } else {
                                this.currentUserIndex = parsedVal.length > 0 ? parsedVal.length - 1 : 0
                                // 종료
                                this.finishEvaluation()
                            }

                            return
                        }
                        console.log('외모 평가를 재생성하지 않았습니다.')
                    }

                    this.loading = false
                    const parsedVal = JSON.parse(newVal)
                    this.users = parsedVal
                    const currentIndex = parsedVal.findIndex(
                        item => item.is_look_accepted === null && item.is_enabled === true
                    )
                    console.log('currentIndex', currentIndex)
                    if (currentIndex >= 0) {
                        this.currentUserIndex = currentIndex
                    } else {
                        this.currentUserIndex = parsedVal.length > 0 ? parsedVal.length - 1 : 0
                        // 종료
                        this.finishEvaluation()
                    }
                }
            },
            immediate: true,
        },
    },
    methods: {
        async updateAiRating() {
            const payload = {
                ai_rating_id: this.aiRating.id,
                evaluation_data: JSON.stringify(this.users),
            }
            console.log('payload', payload)
            const res = await userService.updateAiRating(this.me.id, payload)
            if (res.msg === 'failed') {
                this.$toast.error('문제가 있어서 외모 평가를 저장하지 못 했습니다.')
            }
        },
        async finishEvaluation(hasTargets = true) {
            const idx = await this.$modal.basic({
                title: hasTargets ? 'AI 외모취향 평가 완료' : '외모취향 평가',
                body: hasTargets
                    ? '외모 취향 평가가 완료되었습니다.<br/>AI 외모 추천의 성능은 데이터가 많을수록 정확해집니다.<br/>본 평가 이외에도 수락/거절 사유를 잘 선택해주세요 :)'
                    : '평가 대상 인원이 충분하지 않습니다. 인원이 확보되면 다시 평가 요청 드리도록 하겠습니다.',
                buttons: [
                    {
                        label: '확인',
                        class: 'btn-primary',
                    },
                ],
                preventCloseOnMousedownMask: true,
            })
            if (idx === 0) {
                this.$router.push({ name: 'HomePage' })
            }
        },
        nextUser() {
            // if (this.currentUserIndex < this.users.length - 1) {
            //     this.currentUserIndex++
            // } else if (this.currentUserIndex === this.users.length - 1) {
            //     // 종료
            //     this.finishEvaluation()
            // }

            const indexMap = []
            this.users.forEach((user, index) => {
                if (user.is_enabled) {
                    indexMap.push(index)
                }
            })
            const indexMapCurrentIndex = indexMap.indexOf(this.currentUserIndex)
            const nextIndex = indexMap[indexMapCurrentIndex + 1]
            console.log('indexMap', indexMap)
            console.log('indexMapCurrentIndex', indexMapCurrentIndex)
            console.log('nextIndex', nextIndex)
            if (indexMapCurrentIndex + 1 <= indexMap.length - 1) {
                this.currentUserIndex = nextIndex
            } else if (indexMapCurrentIndex === indexMap.length - 1) {
                // 종료
                this.finishEvaluation()
            }
        },
        prevUser() {
            // if (this.currentUserIndex > 0) {
            //     this.currentUserIndex--
            // }

            const indexMap = []
            this.users.forEach((user, index) => {
                if (user.is_enabled) {
                    indexMap.push(index)
                }
            })
            const indexMapCurrentIndex = indexMap.indexOf(this.currentUserIndex)
            if (indexMapCurrentIndex > 0) {
                this.currentUserIndex = indexMap[indexMapCurrentIndex - 1]
            }
        },
        slideToUser(index) {
            this.$refs.mySwiper.swiper.slideTo(index)
        },
        async goBackHandler() {
            await this.$store.dispatch('loadMe')
            this.$router.go(-1)
        },
        async goHomeHandler() {
            await this.$store.dispatch('loadMe')
            this.$router.go(-1)
        },
        goNextPage() {
            console.log('goNextPage called')

            this.$router.push('/evaluation/main')
        },

        rejectTarget() {
            console.log('rejectTarget called')
            this.users[this.currentUserIndex].is_look_accepted = false
            this.updateAiRating()
            this.nextUser()
        },
        acceptTarget() {
            console.log('acceptTarget called')
            this.users[this.currentUserIndex].is_look_accepted = true
            this.updateAiRating()
            this.nextUser()
        },
    },
}
</script>

<style lang="scss" scoped>
.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-message {
        margin-top: 16px;
        color: black;
        font-size: 14px;
    }
}

.eval-page {
    padding-left: 20px;
    padding-right: 20px;
}
.section-one {
    margin: 0 0 40px 0;

    .title-box {
        margin-bottom: 23px;

        .icon {
            margin-bottom: 8px;
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }

        .title {
            color: var(--Gray-313131, #313131);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 140%; /* 33.6px */
        }

        .desc {
            color: var(--Grey-787878, #787878);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            font-family: Pretendard;
            font-size: 11px;
            font-style: normal;
            font-weight: 300;
            line-height: 150%; /* 16.5px */
        }
    }

    .icon-grid {
        display: grid;
        // grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-template-columns: repeat(2, 100px); /* 아이템 고정 너비 */
        grid-auto-rows: 110px; /* 각 줄의 높이 고정 */
        justify-content: center; /* 그리드 전체를 가로 중앙 정렬 */
        gap: 6px;

        .icon-box {
            width: 100px;
            height: 110px;
            background-color: #f3f6ff;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;

            .icon {
                font-size: 50px;
                font-family: Pretendard;
            }
            .text {
                font-size: 15px;
                font-family: Pretendard;
                font-weight: bold;
                color: #313131;
            }
        }
    }
}
.section-two {
    .title {
        color: var(--Deep-Purple, #181f39);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%; /* 17px */

        margin-bottom: 8px;
    }
    .desc {
        color: var(--Red, #f64f56);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 300;
        line-height: 100%; /* 11px */

        margin-bottom: 23px;
    }

    .target-box {
        position: relative;
        padding: 0px;
        border-radius: 10px;
        background: #f7f8f9;
        overflow: hidden;

        .user-index-box {
            z-index: 2;
            position: absolute;
            right: 8px;
            top: 8px;

            display: flex;
            padding: 2px 5px;
            justify-content: center;
            align-items: center;
            gap: 10px;

            border-radius: 5px;
            background: #fff;

            color: var(--Grey-787878, #787878);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%; /* 18px */
        }

        .slide-img-wrapper {
            position: relative;

            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;

            .user-image {
                width: 100%;
                // max-width: 300px;
                object-fit: cover;
            }

            .bottom-inner-shadow {
                position: absolute;
                bottom: 0px;

                width: 100%;
                height: 64px;

                background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
            }
        }

        .target-info {
            position: absolute;
            bottom: 13px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;

            display: flex;
            justify-content: center;
            align-items: center;

            color: var(--White, #fff);
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%; /* 27px */

            > div {
                width: 100px;
                display: flex;
                align-items: center;
            }

            .left {
                justify-content: right;
                padding-right: 10px;

                border: 0 solid #fff;
                border-right-width: 1px;
                border-left-width: 0px;
            }
            .right {
                justify-content: left;
                padding-left: 10px;
            }
        }
    }

    // .target-box {
    //     padding: 10px;
    //     border-radius: 10px;
    //     background: #F7F8F9;

    //     .slide-img-wrapper {
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         height: 300px;

    //         .user-image {
    //             width: 100%;
    //             max-width: 300px;
    //             object-fit: cover;
    //         }
    //     }

    //     .target-info {
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;

    //         color: var(--Purple, #151360);
    //         text-align: center;
    //         font-feature-settings: 'liga' off, 'clig' off;
    //         font-family: Pretendard;
    //         font-size: 12px;
    //         font-style: normal;
    //         font-weight: 500;
    //         line-height: 150%; /* 18px */

    //         > div {
    //             width: 100px;
    //             display: flex;
    //             gap: 10px;
    //             align-items: center;

    //         }

    //         .left {
    //             justify-content: right;
    //             padding-right: 10px;

    //             border: 0 solid rgba(217, 217, 217, 1);
    //             border-right-width: 1px;
    //             border-left-width: 0px;
    //             // border-color: rgba(217, 217, 217, 1);

    //             img {
    //                 width: 15px;
    //                 height: 15px;
    //             }
    //         }
    //         .right {
    //             justify-content: left;
    //             padding-left: 10px;
    //         }
    //     }
    // }
}
.section-three {
    display: flex;
    justify-content: center;
    align-items: start;
    gap: 4px;

    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 23px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 17px */
        }

        &.reject {
            background: var(--Red, #f64f56);
        }
        &.accept {
            background: var(--Purple, #151360);
        }
    }
}
</style>
